.stamp {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
  font-weight: 600;
  line-height: 1;
  padding: 0.125rem 0.375rem;
  border: 1px solid currentColor;
  border-radius: var(--radius-s);
  color: var(--stamp-color);
  background: color-mix(in srgb, var(--stamp-color) 10%, transparent);
  white-space: nowrap;
}

.ok {
  --stamp-color: var(--ok);
}

.warn {
  --stamp-color: var(--warn);
}

.stop {
  --stamp-color: var(--stop);
}

.you {
  --stamp-color: var(--you);
}

/* Muted on purpose. `not_confirmed_yet` is the most common verdict in real
   data (63 of 81 runs when measured); giving it a signal colour would make
   four screens in five look like they were shouting. */
.open {
  --stamp-color: var(--muted);
}
